module.exports = __webpack_public_path__ + "img/icon-close.b935514e.png";